import { render } from "./personalReply.vue?vue&type=template&id=0c2db91c&scoped=true"
import script from "./personalReply.vue?vue&type=script&lang=js"
export * from "./personalReply.vue?vue&type=script&lang=js"

import "../../forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./personalReply.vue?vue&type=style&index=1&id=0c2db91c&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2db91c"]])

export default __exports__